import { render, staticRenderFns } from "./u-tit-wrap-line.vue?vue&type=template&id=79870544&scoped=true&"
import script from "./u-tit-wrap-line.vue?vue&type=script&lang=js&"
export * from "./u-tit-wrap-line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79870544",
  null
  
)

export default component.exports